module.exports = __webpack_public_path__ + "img/44.a5e270ec.jpg";